import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/blog.css";
import App from "@/App";

// Suppress the well-known benign Radix-Select / ResizeObserver warning
// "ResizeObserver loop completed with undelivered notifications" — it surfaces
// as a CRA red error overlay in dev but is harmless in production.
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (e?.message && e.message.includes("ResizeObserver loop")) {
      e.stopImmediatePropagation();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
